import * as React from 'react';
import styled from "styled-components";

interface CardProps {
  value: string | number;
  title: string;
  description: string;
}

const Value = styled.div`
  font-size: 36px;
  font-style: normal;
  font-weight: 600;
  line-height: 50px;
  letter-spacing: 0.01em;
  color: #3264EF;
`

const Title = styled.div`
  font-size: 18px;
  font-weight: 600;
  line-height: 25px;
  letter-spacing: 0.01em;
`

const Description = styled.div`
  font-size: 14px;
  font-weight: 300;
  line-height: 21px;
  letter-spacing: 0.01em;
  color: #67686B;
`

export const Container = styled.div`
  width: 100%;
  max-width: 359px;
  min-height: 215px;
  padding: 20px;
  display: grid;
  gap: 6px;
  border: 1px solid #EDF0F5;
  box-sizing: border-box;
  box-shadow: 10px 5px 10px rgba(208, 211, 219, 0.1);
  border-radius: 20px;

  @media screen and (max-width: 1270px) {
    min-height: 173px;
    
    ${Value} {
      font-size: 24px;
      font-weight: 600;
      line-height: 34px;
      letter-spacing: 0.01em;
    }
    
    ${Title} {
      font-size: 16px;
      font-weight: 600;
      line-height: 22px;
      letter-spacing: 0.01em;
    }
  }
`;

/**
 * render landing page platform features card
 * @constructor
 */
export default function Card(props: CardProps): React.ReactElement {
  return (
    <Container>
      <Value>{props.value}</Value>
      <Title>{props.title}</Title>
      <Description>{props.description}</Description>
    </Container>
  );
}
